import { useMutation } from "@tanstack/react-query";
import { updatePageModuleStatus } from "../api/updatePageModuleStatus";
import { invalidateModuleListByBrandPageQuery } from "../queries/useModuleListByBrandPageQuery";
import { PageModuleStatus } from "../types";

type Params = {
  moduleId: string;
  status: PageModuleStatus;
};

export const useUpdatePageModuleStatusMutation = ({
  brandId,
  pageId,
}: {
  brandId: string;
  pageId: string;
}) => {
  return useMutation({
    mutationFn: async ({ moduleId, status }: Params) => {
      return await updatePageModuleStatus({
        moduleId,
        status,
        brandId,
        pageId,
      });
    },
    onSuccess: () => {
      invalidateModuleListByBrandPageQuery(brandId, pageId);
    },
    onError: (e) => {
      console.error("Error occurred when updating module", e);
    },
  });
};
